import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import Collapse from "@material-ui/core/Collapse";
import TextField from "@material-ui/core/TextField";

import getLogger from "utils/logger.util";
import { ChartStrings, dashBoardMenuStrings, LAYOUT_STRINGS } from "constants/constantStrings";
import { valueStrings } from "constants/constantStrings.js";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import BadgeLabel from "components/BadgeLabel";
import PopoverText from "components/PopoverText";

import InfoIconGreen from "assets/Other/info-icon-green.svg";
import SearchDashboard from "assets/SecondarySideBar/search_icon.svg";

import AddWidgetModal from "../../components/AddWidgetModal";
import { AnalyticsStrings } from "../../constants/constantStrings";
import Reports from "../../pages/Report/Reports";
import { textFieldUseStyles } from "../../styles/textField";

import LayoutAddForm from "./LayoutAddForm";
import LayoutEdit from "./LayoutEdit";
import LayoutItem from "./LayoutItem";
import NoLayoutsView from "./NoLayoutsView";

import "./LayoutDropdown.scss";

function LayoutDropdown(props) {
  const Logger = getLogger("LayoutDropdown");
  const classes = textFieldUseStyles(this);
  const [filterValue, setFilterValue] = useState("");
  const [adminsOnlyAllUsersAndLayouts] = useState({});
  const [layoutCount, setLayoutCount] = useState(null);
  const [showSeachbox, setShowSeachbox] = useState(false);
  const [editLayoutData, setEditLayoutData] = useState(null);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => setLayoutCount(props.layouts.length), []);
  useEffect(() => toggleSearchIcon(), [layoutCount]);

  useEffect(() => {
    setFilterValue("");
    if ((props.layouts.length > layoutCount || props.layouts.length < layoutCount) && layoutCount !== null) {
      setLayoutCount(props.layouts.length);
    }
  }, [props.currentLayout]);

  const handleFilterChange = event => setFilterValue(event.target.value);

  const handleOpenAddLayoutForm = async () => {
    try {
      if (!props.isAddLayoutFormOpen && props.admin === true) {
        props.setIsAddLayoutFormOpen(true);
      } else {
        props.setIsAddLayoutFormOpen(!props.isAddLayoutFormOpen);
      }
    } catch (err) {
      Logger.error("handleOpenAddLayoutForm - Error: ", err);
    }
  };

  const showSearchBox = () => {
    setShowSeachbox(!showSeachbox);
    setFilterValue("");
  };

  const toggleSearchIcon = () => setShowSearchIcon(layoutCount);

  const headerHeight = headerRef?.current?.offsetHeight || 80;

  const sideNavContentHeight = {
    height: `calc(100% - ${headerHeight}px)`
  };

  const onLayoutEdit = layoutData => {
    setEditLayoutData(layoutData);
    props.setIsEditLayoutFormOpen(true);
  };

  return (
    <div>
      <div ref={headerRef} className="layout-select-popover">
        <div className="layout-select-top" style={{ justifyContent: "space-between" }}>
          <div className="layout-select-top-Content">
            <BadgeLabel badgeDescription={props.page} badgeText={props.layouts?.length} />
          </div>
          {props.isAddLayoutFormOpen !== undefined && (
            <div className="layout-select-top-Content">
              <div className="pointer padding5 addDashboard" type="button" onClick={handleOpenAddLayoutForm} />
              {showSearchIcon && <div className="pointer padding5 searchIcon" type="button" onClick={showSearchBox} />}
            </div>
          )}
          <Collapse className="fullWidth" style={{ position: "absolute" }} in={showSeachbox}>
            <TextField
              fullWidth
              id="searchBox"
              autoComplete="off"
              placeholder={`${valueStrings.search} ${props.page}`}
              className={classes.input}
              value={filterValue}
              onChange={handleFilterChange}
              name="filterLayout"
              InputProps={{
                className: classes.textfield,
                disableUnderline: true,
                startAdornment: <img className="padding5" src={SearchDashboard} alt="searchDashboard" />,
                endAdornment: <div id="searchCross" className="pointer crossIcon padding10" type="button" onClick={showSearchBox} />
              }}
            />
          </Collapse>
          {props.isAddLayoutFormOpen && (
            <LayoutAddForm
              systemID={props.systemID}
              admin={props.admin}
              page={props.page}
              isAddLayoutFormOpen={props.isAddLayoutFormOpen}
              setIsAddLayoutFormOpen={props.setIsAddLayoutFormOpen}
              adminsOnlyAllUsersAndLayouts={adminsOnlyAllUsersAndLayouts}
              setIsDashboardRerendering={props.setIsDashboardRerendering}
              setIsReportRerendering={props.setIsReportRerendering}
              dropdownCurrentLayout={props.currentLayout}
              layoutId={props.layoutId}
              backBtnTooltip={LAYOUT_STRINGS.back}
            />
          )}
          {props.isEditLayoutFormOpen && (
            <LayoutEdit
              page={props.page}
              systemID={props.systemID}
              currentLayout={editLayoutData}
              isEditLayoutFormOpen
              setIsEditLayoutFormOpen={props.setIsEditLayoutFormOpen}
              autogenerate={props.autogenerate}
              setAutogenerate={props.setAutogenerate}
              setIsReportRerendering={props.setIsReportRerendering}
            />
          )}
          {props.isAddWidgetFormOpen && props.isLeftSideNavOpen && (
            <AddWidgetModal data={props} admin={props.admin} setIsAddWidgetFormOpen={props.setIsAddWidgetFormOpen} />
          )}
        </div>
        <div className="descriptionText ">
          {props.page === SYSTEMS_PAGES.CHARTS && ChartStrings.layoutText}
          {props.page === SYSTEMS_PAGES.ANALYTICS && AnalyticsStrings.layoutText}
          {props.setIsDashboardRerendering && (
            <>
              {dashBoardMenuStrings.dashboardMenuDescription}
              <PopoverText descriptor={<img src={InfoIconGreen} alt="icon" />} descriptionText={LAYOUT_STRINGS.layoutInfo} customClass="60px" />
            </>
          )}
          {props.setIsReportRerendering && <Reports props={props} sysId={props.systemID} />}
        </div>
      </div>
      <ul className="dashboardNames " style={sideNavContentHeight}>
        {props.layouts.length ? (
          props.layouts
            .filter(layout => {
              if (filterValue === "") return true;
              if (layout.Name.toLowerCase().includes(filterValue.toLowerCase())) return true;
              if (layout?.PrimaryMail && layout.PrimaryMail.toLowerCase().includes(filterValue.toLowerCase())) return true;
            })
            .map(layout => (
              <LayoutItem
                setIsDashboardRerendering={props.setIsDashboardRerendering}
                setIsReportRerendering={props.setIsReportRerendering}
                setIsChartRerendering={props.setIsChartRerendering}
                name={layout.Name}
                home={layout.Home}
                key={layout.ID}
                layout={layout}
                page={props.page}
                admin={props.admin}
                systemID={props.systemID}
                userName={layout.Username}
                user={layout?.PrimaryMail || ""}
                selected={!(props.currentLayout === undefined || props.currentLayout.ID !== layout.ID)}
                onLayoutEdit={onLayoutEdit}
                setIsEditLayoutFormOpen={props.setIsEditLayoutFormOpen}
                setIsAddWidgetFormOpen={props.setIsAddWidgetFormOpen}
              />
            ))
        ) : (
          <NoLayoutsView />
        )}
      </ul>
    </div>
  );
}

const getLayouts = (layouts, ownProps) => {
  let result = [];
  const { page, systemID } = ownProps;
  const systemsLayout = layouts[systemID];
  if (systemsLayout) {
    result = systemsLayout[page] || [];
  }
  return result;
};

const mapStateToProps = ({ layout, user }, ownProps) => ({
  admin: user.isAdmin,
  layouts: getLayouts(layout.layouts, ownProps),
  currentLayout: getLayouts(layout.currentLayouts, ownProps)
});

export default connect(mapStateToProps, null)(LayoutDropdown);
